<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <app-breadcrumb [segments]="breadcrumbSegments"></app-breadcrumb>
    </div>
  </div>
</div>
<mat-card class="mat-card-flat mat-card-flat--dark">
  <mat-card-header class="pt-0">
    <mat-card-title>
      <h1>My Organizations</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-card class="mt-4 mb-3">
      <mat-card-title class="d-flex"></mat-card-title>
      <mat-card-content>
        <app-datatable
          data-automation-id="my-groups_202127111952"
          [columns]="columns"
          [dataUrl]="dataUrl"
          [defaultSort]="defaultSort"
          [scrollV]="false"
          [scrollH]="false"
          [disableFiltering]="true"
        ></app-datatable>
        <ng-template #entityNameTemplate let-row="row" let-value="value">
          <a
            *ngIf="getDetailsLink(row) as detailsUrl; else noDetailsLinkTemplate"
            class="mat-button-link"
            data-automation-id="my-groups_202127111957"
            tabindex="0"
            [routerLink]="detailsUrl"
          >
            {{ value }}
          </a>
          <ng-template #noDetailsLinkTemplate>
            <span data-automation-id="my-groups_202127112001">{{ value }}</span>
          </ng-template>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
